import { motion } from 'framer-motion';
import { Linkedin } from 'lucide-react';

const HostSection = () => {
  return (
    <section className="bg-slate-50 py-20 lg:py-24 border-y border-slate-100" data-testid="host-section">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid md:grid-cols-[300px_1fr] gap-10 lg:gap-14 items-center">
          {/* Host Photo */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="relative max-w-xs mx-auto md:mx-0">
              <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-purple-500/20 to-blue-500/20 blur-lg pointer-events-none" />
              <img
                alt="Haroon Naseer, founder of Protego AI"
                className="relative w-full rounded-3xl object-cover object-top shadow-xl ring-4 ring-white"
                src="https://thankyou.section3.ai/assets/haroon.jpg"
                data-testid="host-photo"
              />
              <img
                alt="Amazon Selling Partner Appstore — Official Software Partner"
                className="relative h-10 w-auto mx-auto mt-5 drop-shadow-sm"
                loading="lazy"
                src="/amazon-partner-badge.png"
              />
              <a
                href="https://www.linkedin.com/in/iamharoon/"
                target="_blank"
                rel="noopener noreferrer"
                className="relative mt-4 mx-auto flex w-fit items-center gap-2 bg-[#0A66C2] hover:bg-[#084d94] active:scale-[0.97] text-white font-display font-bold text-sm rounded-full px-5 py-2.5 transition-all duration-200 shadow-lg shadow-[#0A66C2]/30"
                data-testid="host-linkedin"
              >
                <Linkedin className="w-4 h-4 fill-white" />
                Connect on LinkedIn
              </a>
            </div>
          </motion.div>

          {/* Host Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-purple-600">
              Your Host
            </p>
            <h2 className="font-display text-slate-800 text-3xl sm:text-4xl mt-3">
              Hosted by Haroon Naseer
            </h2>
            <p className="text-slate-500 text-base leading-relaxed mt-4 max-w-xl">
              Founder of Protego AI. 10 years in Amazon account health and 2,000+ account reinstatements — the operator you want in your corner before Amazon acts.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-3 mt-8 max-w-md">
              <div className="bg-white rounded-xl border border-slate-200 p-4 text-center">
                <p className="font-display text-red-500 text-lg">10 yrs</p>
                <p className="text-[10px] text-slate-500 mt-1 leading-tight">In Amazon account health</p>
              </div>
              <div className="bg-white rounded-xl border border-slate-200 p-4 text-center">
                <p className="font-display text-red-500 text-lg">2,000+</p>
                <p className="text-[10px] text-slate-500 mt-1 leading-tight">Account reinstatements</p>
              </div>
              <div className="bg-white rounded-xl border border-slate-200 p-4 text-center">
                <p className="font-display text-red-500 text-lg">Founder</p>
                <p className="text-[10px] text-slate-500 mt-1 leading-tight">Protego AI</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HostSection;
